module.exports = __webpack_public_path__ + "img/4_ParqMov.b95da176.png";